import React from 'react';
import PropTypes from 'prop-types';
import { Loader } from 'components';
import './styles.scss';

const PageLoader = ({ className = '' }) => (
    <div className={`content ${className}`}>
        <div className="page-loader-content">
            <Loader size="big" />
        </div>
    </div>
);

PageLoader.propTypes = {
    className: PropTypes.string,
};

export default PageLoader;
